import { render, staticRenderFns } from "./HuchaCrear.vue?vue&type=template&id=18e1eb9a&scoped=true"
import script from "./HuchaCrear.vue?vue&type=script&lang=js"
export * from "./HuchaCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1eb9a",
  null
  
)

export default component.exports